import React from 'react';
import Header from '../components/Header';
import AboutSection from '../components/AboutSection';
import ServiceTabs from '../components/ServiceTabs';
import OnlinePlatform from '../components/OnlinePlatform';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import PricingSection from '../components/PricingSection';

const ArauclinHomePage = () => {
  return (
    <div className="app">
      <Header />
      <PricingSection />
      <AboutSection />

      <Footer />
    </div>
  );
};

export default ArauclinHomePage;
